import { useState, useEffect } from 'react'
import { Box, Button, Typography, Checkbox, Divider } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const PagesFilters = ({
  filtersOpen,
  setFiltersOpen,
  selectedScanStatus,
  setSelectedScanStatus,
  allIssueTypes,
  selectedIssueTypes,
  setSelectedIssueTypes,
  selectedTestCasesStatus,
  setSelectedTestCasesStatus
}) => {
  const [newScanStatus, setNewScanStatus] = useState('All')
  const [newSelectedIssueTypes, setNewSelectedIssueTypes] = useState([])
  const [newTestCasesStatus, setNewTestCasesStatus] = useState('All')

  useEffect(() => {
    setNewScanStatus(selectedScanStatus)
    setNewSelectedIssueTypes(selectedIssueTypes)
    setNewTestCasesStatus(selectedTestCasesStatus)
  }, [selectedScanStatus, selectedIssueTypes, selectedTestCasesStatus])

  const handleClose = () => {
    setFiltersOpen(false)
  }

  const handleReset = () => {
    setSelectedScanStatus('All')
    setSelectedIssueTypes(allIssueTypes.map(type => type.description))
    setSelectedTestCasesStatus('All')
    handleClose()
  }

  const handleApply = () => {
    setSelectedScanStatus(newScanStatus)
    setSelectedIssueTypes(newSelectedIssueTypes)
    setSelectedTestCasesStatus(newTestCasesStatus)
    handleClose()
  }

  const handleIssueTypeChange = (event) => {
    if (event.target.checked) {
      setNewSelectedIssueTypes([...newSelectedIssueTypes, event.target.value])
    } else {
      setNewSelectedIssueTypes(newSelectedIssueTypes.filter(type => type !== event.target.value))
    }
  }

  return (
    <Box className='pagesFiltersContainer' sx={{ width: filtersOpen ? '320px' : '0' }}>
      <Box className='pagesFilters'>
        <Box className='pagesFiltersContent'>
          <Button className="pagesFiltersCloseButton" onClick={handleClose}>
            <CloseIcon className="pagesFiltersCloseButtonIcon" />
            <Typography className="pagesFiltersCloseButtonText">Close</Typography>
          </Button>
          <Typography className='pagesFiltersTitle'>Filters</Typography>
          <Box className='pagesFilterSection'>
            <Typography className='pagesFilterSectionTitle'>UI Scan Status</Typography>
            <Box className='statusSectionContent'>
              <Button
                className="statusButton allButton"
                onClick={() => setNewScanStatus('All')}
                color='secondary'
                variant={ newScanStatus === 'All' ? 'contained' : 'outlined' }
              >
                All
              </Button>
              <Button
                className="statusButton scannedButton"
                onClick={() => setNewScanStatus('Scanned')}
                color='secondary'
                variant={ newScanStatus === 'Scanned' ? 'contained' : 'outlined' }
              >
                Scanned
              </Button>
              <Button
                className="statusButton unscannedButton"
                onClick={() => setNewScanStatus('Unscanned')}
                color='secondary'
                variant={ newScanStatus === 'Unscanned' ? 'contained' : 'outlined' }
              >
                Unscanned
              </Button>
            </Box>
          </Box>
          <Box className='pagesFilterSection'>
            <Typography className='pagesFilterSectionTitle'>UI Issue Type</Typography>
            <Box className='issueTypesSectionContent'>
              {allIssueTypes.map((type) => (
                <Box key={type.id} className='issueTypeContainer'>
                  <Checkbox
                    checked={newSelectedIssueTypes.includes(type.description)}
                    value={type.description}
                    onChange={handleIssueTypeChange}
                    disabled={type.description === "Server response error (e.g., 401, 403)"}
                  />
                  <Typography >{type.description}</Typography>
                </Box>
              ))}
            </Box>
          </Box>
          <Divider className='pagesFilterDivider'/>
          <Box className='pagesFilterSection'>
            <Typography className='pagesFilterSectionTitle'>Test Cases Status</Typography>
            <Box className='statusSectionContent'>
              <Button
                className="statusButton allButton"
                onClick={() => setNewTestCasesStatus('All')}
                color='secondary'
                variant={ newTestCasesStatus === 'All' ? 'contained' : 'outlined' }
              >
                All
              </Button>
              <Button
                className="statusButton generatedButton"
                onClick={() => setNewTestCasesStatus('Generated')}
                color='secondary'
                variant={ newTestCasesStatus === 'Generated' ? 'contained' : 'outlined' }
              >
                Generated
              </Button>
              <Button
                className="statusButton notGeneratedButton"
                onClick={() => setNewTestCasesStatus('Not Generated')}
                color='secondary'
                variant={ newTestCasesStatus === 'Not Generated' ? 'contained' : 'outlined' }
              >
                Not Generated
              </Button>
            </Box>
          </Box>
        </Box>
        <Box className='pagesFiltersActions'>
          <Button
            className="pagesFiltersActionButton"
            onClick={handleReset}
            variant='outlined'
            color='secondary'
          >
            RESET
          </Button>
          <Button
            className="pagesFiltersActionButton"
            onClick={handleApply}
            variant='contained'
            color='secondary'
          >
            APPLY
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default PagesFilters